/**
 * Símbolo do FluxFin — quadrado girado 45°, derivado do losango do logo do
 * cliente. Substitui a gota d'água em toda a aplicação.
 *
 * Sobre fundo escuro: losango verde com o quadrado vazado em navy.
 * Sobre fundo claro: losango azul com o quadrado vazado em branco.
 *
 * Nunca substitui o logo do cliente — no login os dois convivem.
 */
export default function Marca({ tamanho = 40, sobre = 'escuro' }) {
  const claro = sobre === 'claro';
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
      style={{ flex: 'none', display: 'block' }}
    >
      <g transform="rotate(45 20 20)">
        <rect x="5" y="5" width="30" height="30" fill={claro ? '#17539B' : '#45C08A'} />
        <rect
          x="12.5"
          y="12.5"
          width="15"
          height="15"
          fill="none"
          stroke={claro ? '#FFFFFF' : '#0F3D74'}
          strokeWidth="4"
        />
      </g>
    </svg>
  );
}
